import {ImageUploadCard} from '../../../components/ImageUploadCard';
import {isObjectEmpty} from '../../../helpers/objectHelper';
import CustomButton from '../../../components/CustomButton';
import CustomModal from '../../../components/CustomModal';
import {isEmpty} from 'lodash';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isNotEmpty} from '../../../helpers/stringHelper';
import LabeledSelect from '../../../components/selects/LabeledSelect';
import BrandSearchSelect from '../../../components/selects/BrandSearchSelect';
import CategorySearchSelect from '../../../components/selects/CategorySearchSelect';
import ProductSearchSelect from '../../../components/selects/ProductSearchSelect';
import SpecialBrandSelect from '../../../components/selects/SpecialBrandsSelect';
import BrandWeekSelect from '../../../components/selects/BrandWeekSelect';
import {
  getFormattedSeoUrl,
  getReverseFormattedSeoUrl
} from 'helpers/seoHelper';
import {
  groupOptions,
  users,
  screens,
  displayBrandSearch,
  displayProductSearch,
  displayCampaignSearch,
  displayCategorySearch,
  displayBrandWeekSearch,
  displayBrandDaySearch,
  displayProductCampaign
} from './constants';
import {PRODUCT_CAMPAIGN_TYPE} from '../../focusItems/enums';
import CampaignProductSelect from '../../../components/selects/CampaignProductSelect';
import {tryCreateBanner} from 'redux/slices/bannerSlices';
import {tryUpdateBanner} from 'redux/slices/bannerSlices';
import {tryGetActiveFlashSale} from 'redux/slices/bannerSlices';
import DynamicPagesSelect from 'components/selects/DynamicPagesSelect';

const BannerCreatorModal = ({
                              screen,
                              tab,
                              showModal,
                              setShowModal,
                              oldData
                            }) => {
  const dispatch = useDispatch();
  const [mobileBanner, setMobileBanner] = useState('');
  const [webBanner, setWebBanner] = useState('');


  // const [selectedUserType, setSelectedUserType] = useState(users[0])
  const [selectedScreen, setSelectedScreen] = useState();

  const [selectedGroup, setSelectedGroup] = useState({});
  const [group, setGroup] = useState('');
  const [subGroup, setSubGroup] = useState('');

  const [title, setTitle] = useState('');
  const [seoDetail, setSeoDetail] = useState({});

  // common for all search/select
  const [selectedOption, setSelectedOption] = useState(null);
  const [ext, setExt] = useState(null);

  const {
    pages: {data},
    banners: {processing, toggle},
    flashSale
  } = useSelector((state) => state.banner);

  useEffect(() => {
    resetForm();
  }, [toggle]);

  useEffect(() => {
    resetForm();
  }, [toggle]);

  useEffect(() => {
    if (oldData?.action_url) {
      if (!isEmpty(oldData)) {
        const url = new URL(oldData.action_url);
        const productsSubGroup = groupOptions[0].subGroupOptions.map(
          (option) => option.value
        );
        let groupAndSubGroup = url.pathname.slice(1).split('/');
        const selectedOption = groupOptions.filter(
          (option) => option.value === groupAndSubGroup[0]
        );

        resetIdTitleAndSelectedOption();
        setMobileBanner(oldData?.image ?? "");
        setWebBanner(oldData?.image_for_web ?? "");
        setSelectedScreen(data.find((d) => d.id === oldData.banner_type));

        if (
          groupAndSubGroup[0] === 'products' &&
          !productsSubGroup.includes(groupAndSubGroup[1])
        ) {
          setSubGroup('details');
        } else if (
          groupAndSubGroup[0] === 'brands' &&
          groupAndSubGroup[1] === undefined
        ) {
          setSubGroup('normal');
        } else if (
          groupAndSubGroup[0] === 'brands' &&
          groupAndSubGroup[1] !== 'featured'
        ) {
          setSubGroup('campaign');
        } else {
          setSubGroup(groupAndSubGroup[1]);
        }

        if (selectedOption[0]) {
          setSelectedGroup(selectedOption[0]);
          setGroup(selectedOption[0].value);
          const {name, id} = getReverseFormattedSeoUrl(
            groupAndSubGroup[groupAndSubGroup.length - 1]
          );
          if (
            groupAndSubGroup[0] === 'products' &&
            !productsSubGroup.includes(groupAndSubGroup[1])
          ) {
            // setSelectedOption({id, label: name})
            setExt({id, label: name});
          } else {
            setExt({id, name});
            // setSelectedOption({id, name})
          }
        } else {
          setGroup("pages");
          const {name, id} = getReverseFormattedSeoUrl(
            groupAndSubGroup[groupAndSubGroup.length - 1]
          );
          setExt({id, label: name});
        }

        if (selectedOption[0]?.value === 'flash-sale') {
          dispatch(tryGetActiveFlashSale());
        }
      }
    }
    setMobileBanner(oldData?.image ?? "");
    setWebBanner(oldData?.image_for_web ?? "");
    setSelectedScreen(data.find((d) => d.id === oldData?.banner_type));
    setTitle(oldData?.title);
  }, [oldData]);

  const resetForm = () => {
    setMobileBanner('');
    setWebBanner('');
    setShowModal(false);
    setSelectedScreen();
    setSelectedGroup({});
    setGroup('');
    resetIdTitleAndSelectedOption();
    setSeoDetail({});
    setExt(null);

  };

  const resetIdTitleAndSelectedOption = () => {
    setSelectedOption(null);
    setTitle('');
  };

  const isDoctorSelected = selectedScreen?.title === 'DOCTOR';

  const isAllValid = () => {
    const isImageValid = isNotEmpty(mobileBanner) && isNotEmpty(webBanner);

    if (isNotEmpty(selectedScreen?.title) && !isDoctorSelected) {
      const commonValid = isImageValid && isNotEmpty(selectedScreen?.title);

      switch (group) {
        case 'products':
          if (
            subGroup === 'categories' ||
            subGroup === 'brand' ||
            subGroup === 'details' ||
            subGroup === 'brand_day' ||
            subGroup === 'brand_week'
          ) {
            return (
              commonValid && isNotEmpty(subGroup) && selectedOption !== null
            );
          } else {
            return commonValid && isNotEmpty(subGroup);
          }
        case 'brands':
          if (subGroup === 'campaign') {
            return (
              commonValid && isNotEmpty(subGroup) && isNotEmpty(seoDetail?.id)
            );
          } else {
            return commonValid && isNotEmpty(subGroup);
          }
        case 'flash-sale':
          if (flashSale.data !== null) {
            return (
              commonValid &&
              isNotEmpty(subGroup) &&
              isNotEmpty(flashSale.data?.id.toString())
            );
          } else {
            return false;
          }
        case 'product-campaigns':
          return commonValid && isNotEmpty(subGroup) && selectedOption !== null;
        case 'pages':
          return commonValid && !isEmpty(seoDetail);
        default:
          return false;
      }
    } else return isImageValid;
  };


  const generateSeoUrl = () => {
    const bannedSubGroup = ['details', 'campaign', 'normal', 'discount'];
    const bannedGroup = ['pages'];

    let actionUrl = `${process.env.REACT_APP_DOMAIN}`;

    if (!bannedGroup.includes(group))
      actionUrl = actionUrl.concat(`/${group}`);

    if (!bannedSubGroup.includes(subGroup) && subGroup?.length) {
      actionUrl = actionUrl.concat(`/${subGroup.toLowerCase()}`);
    }

    if (!isEmpty(seoDetail)) {
      let slugUrl = getFormattedSeoUrl({
        seoDetails: seoDetail?.seo_details,
        title: seoDetail.label ?? seoDetail.name ?? seoDetail.title,
        id: seoDetail.product_id ?? seoDetail.id ?? ''
      });
      actionUrl = actionUrl.concat(`/${slugUrl}`);
    }
    if (seoDetail?.name ?? false) {
      actionUrl = actionUrl.concat(`?title=${seoDetail.name}`);
    }
    return actionUrl;
  };


  const onSetSelectedItem = (item) => {

    setSeoDetail(item);
    setSelectedOption(item);
    setTitle(item?.name ?? item?.label ?? '');
  };


  return (
    <CustomModal
      title={isEmpty(oldData) ? 'Add Banner' : 'Update Banner'}
      showModal={showModal}
      setShowModal={resetForm}
      loading={processing}
      button={<CreateButton webBanner={webBanner} mobileBanner={mobileBanner} processing={processing} title={title}
                            selectedScreen={selectedScreen} generateSeoUrl={generateSeoUrl} isAllValid={isAllValid}
                            oldData={oldData}/>}
    >
      <NewBannerForm mobileBanner={mobileBanner} subGroup={subGroup} group={group} ext={ext} flashSale={flashSale}
                     setMobileBanner={setMobileBanner} setGroup={setGroup} onSetSelectedItem={onSetSelectedItem}
                     selectedOption={selectedOption} selectedScreen={selectedScreen}
                     setSelectedScreen={setSelectedScreen} processing={processing}
                     resetIdTitleAndSelectedOption={resetIdTitleAndSelectedOption} setSelectedOption={setSelectedOption}
                     selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} setSubGroup={setSubGroup}
                     setSeoDetail={setSeoDetail} setWebBanner={setWebBanner} webBanner={webBanner} data={data}
                     oldData={oldData}/>

    </CustomModal>
  );
};

export {BannerCreatorModal};

const NewBannerForm = ({
                         mobileBanner,
                         setMobileBanner,
                         webBanner,
                         setWebBanner,
                         selectedScreen,
                         setSelectedScreen,
                         setSelectedGroup,
                         setGroup,
                         data,
                         setSubGroup,
                         resetIdTitleAndSelectedOption,
                         setSeoDetail,
                         group,
                         selectedGroup,
                         subGroup,
                         onSetSelectedItem,
                         setSelectedOption,
                         selectedOption,
                         ext, flashSale, processing, oldData
                       }) => {
  const dispatch = useDispatch();
  return (
    <div className="space-y-4">
      <div className="flex space-x-6">
        <div className="flex-1">
          <ImageUploadCard
            permanentRemove={false}
            initialImage={mobileBanner}
            title="Mobile"
            onImageUploaded={setMobileBanner}
            onImageRemoved={setMobileBanner}
          />
          <ImageUploadCard
            permanentRemove={false}
            initialImage={webBanner}
            title="Web"
            onImageUploaded={setWebBanner}
            onImageRemoved={setWebBanner}
          />
        </div>
        <div className="flex-1">
          {/*user section*/}
          <>
            <LabeledSelect
              label="Select Screen"
              placeholder="Search Screen"
              options={data}
              value={data.find((o) => o === selectedScreen) ?? ''}
              onChange={setSelectedScreen}
              getOptionLabel={(v) => v.title}
              getOptionValue={(v) => v}
              isDisabled={!isEmpty(oldData)}
            />
            {selectedScreen?.type !== 'DOCTOR' ? (
              <>
                <LabeledSelect
                  label="Select Group"
                  placeholder="Search Group"
                  options={groupOptions}
                  value={groupOptions.find((o) => o.value === group) ?? ''}
                  onChange={(selectedOption) => {
                    setSelectedGroup(selectedOption);
                    setGroup(selectedOption.value);
                    setSubGroup('');
                    resetIdTitleAndSelectedOption();
                    if (selectedOption.value === 'flash-sale') {
                      setSeoDetail({});
                      dispatch(tryGetActiveFlashSale());
                    }
                  }}
                />

                {group !== 'flash-sale' &&
                  group !== 'product-campaigns' &&
                  group !== 'pages' &&
                  <LabeledSelect
                    label={`Select Sub Group`}
                    placeholder="Search Sub Group"
                    options={selectedGroup.subGroupOptions}
                    isDisabled={isObjectEmpty(selectedGroup)}
                    value={
                      selectedGroup?.subGroupOptions?.find(
                        (o) => o.value === subGroup
                      ) ?? ''
                    }
                    onChange={(selectedOption) => {
                      setSubGroup(selectedOption.value);
                      onSetSelectedItem();
                      resetIdTitleAndSelectedOption();
                    }}
                    maxHeight={120}
                  />
                }

                {
                  group === 'product-campaigns' && (
                    <LabeledSelect
                      label={'Select Campaign Type'}
                      value={PRODUCT_CAMPAIGN_TYPE.find(
                        (t) => t.value === subGroup
                      )}
                      options={PRODUCT_CAMPAIGN_TYPE}
                      placeholder={'Select Campaign Type'}
                      onChange={(v) => {
                        setSelectedOption(null);
                        setSubGroup(v.value);
                      }}
                    />
                  )
                }

                {
                  group === 'pages' &&
                  <DynamicPagesSelect
                    label="Select a Dynamic Page"
                    value={selectedOption}
                    extData={ext?.id}
                    onChange={(page) => {
                      onSetSelectedItem(page);
                    }}
                  />

                }


                {group === 'flash-sale' && (flashSale.loading ?
                    <div>'Checking active flash sale...'</div> : flashSale.error ?
                      <div>'Checking active flash sale...'</div>
                      : flashSale.data !== null ?
                        <LabeledSelect
                          label="Select Sub Group"
                          placeholder="Search Sub Group"
                          options={selectedGroup.subGroupOptions}
                          isDisabled={isObjectEmpty(selectedGroup)}
                          value={
                            selectedGroup?.subGroupOptions?.find(
                              (o) => o.value === subGroup
                            ) ?? ''
                          }
                          onChange={(selectedOption) => {
                            setSubGroup(selectedOption.value);
                            resetIdTitleAndSelectedOption();
                          }}
                          maxHeight={120}
                        /> :

                        <div>No Flash Sale currently running</div>
                )}

                {/*Brand search section*/}
                {displayBrandSearch(group, subGroup) && (
                  <BrandSearchSelect
                    label="Select Brand"
                    isDisabled={processing}
                    value={selectedOption}
                    extData={ext?.id}
                    onChange={(brand) => onSetSelectedItem(brand)}
                  />
                )}

                {/*Product search section*/}
                {displayProductSearch(group, subGroup) && (
                  <ProductSearchSelect
                    label="Select Product"
                    isDisabled={processing}
                    extData={ext?.id}
                    value={selectedOption}
                    onChange={(product) => onSetSelectedItem(product)}
                  />
                )}

                {/*Category search section*/}
                {displayCategorySearch(group, subGroup) && (
                  <CategorySearchSelect
                    label="Select Category"
                    isDisabled={processing}
                    value={selectedOption}
                    extData={ext?.id}
                    onChange={(category) => onSetSelectedItem(category)}
                  />
                )}

                {displayCampaignSearch(group, subGroup) && (
                  <SpecialBrandSelect
                    label="Select Campaign Month"
                    isBrandDay={false}
                    value={selectedOption}
                    extData={ext?.id}
                    onChange={(campaign) => onSetSelectedItem(campaign)}
                  />
                )}

                {displayBrandDaySearch(group, subGroup) && (
                  <SpecialBrandSelect
                    label="Select Brand Day"
                    emptyMsg="No brand day available"
                    extData={ext?.id}
                    isBrandDay={true}
                    value={selectedOption}
                    onChange={(brand) => onSetSelectedItem(brand)}
                  />
                )}

                {displayBrandWeekSearch(group, subGroup) && (
                  <BrandWeekSelect
                    extData={ext?.id}
                    label="Select Brand Week"
                    emptyMsg="No brand week available"
                    value={selectedOption}
                    onChange={(brand) => onSetSelectedItem(brand)}
                  />
                )}

                {displayProductCampaign(group, subGroup) && (
                  <CampaignProductSelect
                    label="Search Product Campaign"
                    value={selectedOption}
                    onChange={(campaign) => {
                      onSetSelectedItem(campaign);
                    }}
                    type={subGroup}
                  />
                )}
              </>
            ) : (
              <></>
            )}
          </>
        </div>
      </div>
    </div>
  );
};

const CreateButton = ({
                        oldData,
                        isAllValid,
                        processing,
                        selectedScreen,
                        generateSeoUrl,
                        mobileBanner,
                        webBanner,
                        title
                      }) => {

  const dispatch = useDispatch();
  const createBannerAction = () => {
    const newBanner = {
      title: title,
      ...(selectedScreen?.type !== 'DOCTOR' && {
        action_url: generateSeoUrl()
      }),
      image: mobileBanner,
      image_for_web: webBanner,
      screen: selectedScreen.title
    };
    dispatch(
      tryCreateBanner({banner: newBanner, bannerTypeId: selectedScreen.id})
    );
  };

  const updateBannerAction = () => {
    const newBanner = {
      title: title,
      ...(selectedScreen?.type !== 'DOCTOR' && {
        action_url: generateSeoUrl()
      }),
      image: mobileBanner,
      image_for_web: webBanner,
      screen: selectedScreen.title
    };
    dispatch(
      tryUpdateBanner({
        banner: newBanner,
        bannerId: oldData.id,
        bannerTypeId: selectedScreen.id
      })
    );
  };

  return (
    <CustomButton
      children={isEmpty(oldData) ? 'Create' : 'Update'}
      disabled={!isAllValid() || processing}
      onClick={isEmpty(oldData) ? createBannerAction : updateBannerAction}
    />
  );
};
